import type { GetCompaniesLoaderData } from "~/routes/companies._index/GetCompaniesLoaderData";
import ROUTES from "~/kernel/routing/ROUTES";
import { useFetcher } from "@remix-run/react";
import { useEffect } from "react";

export default function useCompanySearch(query: string) {
  const fetcher = useFetcher<GetCompaniesLoaderData>();
  const load = fetcher.load;

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      load(ROUTES.companies.path(query));
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [load, query]);

  return fetcher;
}
